import {
    experienceRouteHandler,
    filterExperienceRouteHandler,
    filterRouteHandler,
    rootRouteHandler,
    subpageRouteHandler,
} from "./route_handlers";

// Binds the handler's `this` to the passed in OnlineApp.
export function bindRoutes(onlineApp) {

    return {
        '': {
            as: 'root',
            uses: rootRouteHandler.bind(onlineApp)
        },
        '/subpages/:subpage_id': {
            as: 'subpage',
            uses: subpageRouteHandler.bind(onlineApp)
        },
        '/filters/:filter_id': {
            as: 'filter',
            uses: filterRouteHandler.bind(onlineApp)
        },
        '/filters/:filter_id/experiences/:experience_id': {
            as: 'filterExperience',
            uses: filterExperienceRouteHandler.bind(onlineApp)
        },
        '/experiences/:experience_id': {
            as: 'experience',
            uses: experienceRouteHandler.bind(onlineApp)
        }
    }

}

